import React from 'react'
import styled from 'styled-components'
import { GiEarthAmerica } from 'react-icons/gi'
import { MdAirplanemodeInactive,MdTimer } from 'react-icons/md'
import { FaMoneyCheck } from 'react-icons/fa';

const StatsData=[
  
    {
        icon:(<GiEarthAmerica 
            css={`
               color:#03A9F4;
            `}
           />),
        title:'Over 100 places',
        desc:'Lorem impsum dummy data will here'
    },
    {
        icon:(<MdAirplanemodeInactive
            css={`
            color:#FF5722;
         `}
        />),
        title:'Fastest Track',
        desc:'Lorem impsum dummy data will here'
    },
    {
        icon:(<MdTimer
            css={`
            color:brown;
         `}
        />),
        title:'Best Time Managment',
        desc:'Lorem impsum dummy data will here'
    },
    {
        icon:(<FaMoneyCheck
            css={`
            color:#4CAF50;
         `}
        />),
        title:'Money Check',
        desc:'Lorem impsum dummy data will here'
    }

]

const Stats = () => {
  return (
    <StatsContiner>
      <Heading>Why Choose Us ?</Heading>
      <Wrapper>
          {
              StatsData.map((data,index)=>{
               return (<StatsBox key={index}>
                   <Icon>{data.icon}</Icon>
                   <Title>{data.Title}</Title>
                   <Desc>{data.desc}</Desc>
               </StatsBox>
               )
              })
          }
      </Wrapper>
    </StatsContiner>
  )
}

export default Stats;

const StatsContiner=styled.div`
   width:100%;
   background:#fff;
   color: #000;
   display:flex;
   flex-direction:column;
   justify-content:center;
   padding:4rem calc((100vw  - 1300px)/2);
`
const Heading=styled.h1`
     text-align:start;
     font-size:clamp(1.5rem,5vw,2rem);
     margin-bottom:3rem;
     padding:0 2rem;
`
const Wrapper=styled.div`
      display:grid;
      grid-template-columns:repeat(4, 1fr);
      grid-gap:10px;
      @media screen and (max-width:768px){
        grid-template-columns:1fr;
      }
      @media screen and (max-width:500px){
        grid-template-columns:1fr;
      }
`
const StatsBox=styled.div`
 height:100%;
 width:100%;
 padding:2rem;
 transition:0.3s;
`;
const Icon=styled.div`
   font-size:3rem;
   margin-bottom:1rem;
`;
const Title=styled.p`
   font-size:clamp(1rem,2.5vw,1.5rem);
   margin-bottom:0.5rem;
`;
const Desc=styled.p``;



